import React, { Component } from "react";
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../context/WithConsumer';


export default class ModImageTextCols extends Component {
    render () {
	    let block 	= this.props.block;
	    let columns = [];
		for (let i=0;i<block.column.length;i++) {
			let link = '';
			
			if (block.column[i].link_text && block.column[i].link_url) {
				if ( block.column[i].link_url.includes('http') || block.column[i].link_url.includes('https')) {
					link = <a target="_blank" href={block.column[i].link_url} className="c-imagetextcols__column__link">{ block.column[i].link_text }</a>
				} else {
					link = <Link to={block.column[i].link_url} className="c-imagetextcols__column__link">{ block.column[i].link_text }</Link>
				} 
			}
			let columnClass = "l-grid__col l-grid__col--m-4-12 l-grid__col--l-4-12 c-imagetextcols__column";
			if (block.column[i].link_text && block.column[i].link_url) {
				columnClass = columnClass + " c-imagetextcols__column--has-link";
			}
		    columns.push(
		    	<div className={columnClass} key={i}>
		    		<div className="c-imagetextcols__column__inner">
				    	<div className="c-imagetextcols__column__image" style={{paddingTop:block.column[i].padding}}>
							<FadeIn duration={250}>
								{onload => (
									<img
										alt=''
										src={block.column[i].src} 
										srcSet={block.column[i].srcset} 
										onLoad={onload}
									/>
								)}
							</FadeIn>
						</div>
						<div className="scope-text" dangerouslySetInnerHTML={ {__html: block.column[i].text } }></div>
						{ link }
					</div>
				</div>
			);
		};
	    return (
	        <div className={'l-block l-block--display-' + block.display + ' scope-' + block.text_color + ' scope-' + block.image_effect} style={{backgroundColor: block.block_color}}>
	        	<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
		        	<div className="l-grid">
			        	<div className="l-grid__col">
				        	{block.heading &&
					        	<h3 className="c-heading c-heading--large">{ block.heading }</h3>
				        	}
				        	{block.heading &&
					        	<h3 className="c-paragraph c-paragraph--small">{ block.subheading }</h3>
				        	}
			        	</div>
			        </div>
			        <div className="l-grid l-grid--m-even c-imagetextcols">
						{ columns }
			        </div>
				</ScrollAnimation>
			</div>
		)
	};

};
